import React from "react";
import PropTypes from "prop-types";
import "../../styles/PolicyInformation.scss";
import ListItem from "../list-item/ListItem";
import Card from "../card/Card";
import List from "../list/List";

const PolicyInformation = (props) => {
    const { direction, policyInformationData, policyExpired } = props;

    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [month, day, year].join('/');

    }

    const formatPhoneNumber = (phoneNumberString) => {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
        if (match) {
            cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
        }
        return cleaned;
    }

    const getPhoneNumber = () => {
        const data = JSON.parse(localStorage.getItem('tpa_data'));
        if (data?.tel) {
            return formatPhoneNumber(data?.tel);
        }
        return null;
    }

    const getInvalidPolicyTypeMessage = () => {
        const data = JSON.parse(localStorage.getItem('tpa_data'));
        if (!data?.policy_Types.includes(policyInformationData?.type)) {
            return (
                <div className="policy-error-message-container">
                    <i className="fa fa-exclamation-circle polci-expired-icon"></i>
                    <div className="policy-expired-description">
                        We’ve located your contract, but we are unable to process these claim types online. Please call us at <b><u>{getPhoneNumber()}</u></b> for assistance.
                    </div>
                </div>
            )
        }
        return;
    }

    const displayData = () => {
        if (policyInformationData) {
            if (policyExpired) {
                return (
                    <React.Fragment>
                        <div className="card-container card-container--contract-expired">
                            <Card cardTitle="Contract Information" cardIcon="fas fa-file-contract">
                                <div className={"d-flex pl-31 flex-wrap flex-" + direction}>
                                    <List>
                                        <div className="card-col__1 mt-9">
                                            <ListItem itemKey="Contract Number" itemValue={policyInformationData.number} />
                                        </div>
                                        <div className="card-col__1 mt-11 d-flex">
                                            <div className="w-100">
                                                <ListItem itemKey="Policy Type" itemValue={policyInformationData.type} />
                                            </div>
                                            <div className="w-100">
                                                <ListItem itemKey="Status" itemValue={policyInformationData.status} />
                                            </div>
                                        </div>
                                        <div className="card-col__1 mt-11 d-flex">
                                            <div className="w-100">
                                                <ListItem itemKey="Effective Date" itemValue={formatDate(policyInformationData.saleDate)} />
                                            </div>
                                            <div className="w-100">
                                                <ListItem itemKey="Expiration Date" itemValue={formatDate(policyInformationData.expirationDate)} />
                                            </div>
                                        </div>
                                        {/*<div className="d-flex flex-row justify-content-between w-100 flex-wrap mt-11">*/}
                                        {/*    <div className="flex-column">*/}
                                        {/*        <ListItem itemKey="Policy Type" itemValue={policyInformationData.type} />*/}
                                        {/*    </div>*/}
                                        {/*    <div className="flex-column">*/}
                                        {/*        <ListItem itemKey="Status" itemValue={policyInformationData.status} />*/}
                                        {/*    </div>*/}
                                        {/*    <div className="flex-column">*/}
                                        {/*        <ListItem itemKey="Purchase Date" itemValue={formatDate(policyInformationData.saleDate)} />*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        {/*<div className="card-col__1 mt-11">*/}
                                        {/*    <ListItem itemKey="Provider" itemValue={policyInformationData.provider} />*/}
                                        {/*</div>*/}
                                        {/*<div className="card-col__1 mt-11">*/}
                                        {/*    <ListItem itemKey="Phone" itemValue={formatPhoneNumber(policyInformationData.phone)} />*/}
                                        {/*</div>*/}
                                    </List>
                                </div>
                            </Card>
                        </div>
                        <div className="policy-error-message-container">
                            <i className="fa fa-exclamation-circle polci-expired-icon"></i>
                            <div className="policy-expired-description">
                                We’ve located your contract, but it appears to be in {policyInformationData.status.replace(/([A-Z])/g, ' $1').trim()} status. Please call us at <b><u>{getPhoneNumber()}</u></b> for assistance.
                            </div>
                        </div>
                    </React.Fragment>
                )
            }
            return (
                <React.Fragment>
                    <div className="card-container">
                        <Card cardTitle="Contract Information" cardIcon="fas fa-file-contract">
                            <div className={"d-flex pl-31 flex-wrap flex-" + direction}>
                                <List>
                                    <div className="card-col__1 mt-9">
                                        <ListItem itemKey="Contract Number" itemValue={policyInformationData.number} />
                                    </div>
                                    <div className="card-col__1 mt-11 d-flex">
                                        <div className="w-100">
                                            <ListItem itemKey="Policy Type" itemValue={policyInformationData.type} />
                                        </div>
                                        <div className="w-100">
                                            <ListItem itemKey="Status" itemValue={policyInformationData.status} />
                                        </div>
                                    </div>
                                    <div className="card-col__1 mt-11 d-flex">
                                        <div className="w-100">
                                            <ListItem itemKey="Effective Date" itemValue={formatDate(policyInformationData.saleDate)} />
                                        </div>
                                        <div className="w-100">
                                            <ListItem itemKey="Expiration Date" itemValue={formatDate(policyInformationData.expirationDate)} />
                                        </div>
                                    </div>
                                    {/*<div className="d-flex flex-row justify-content-between w-100 mt-11">*/}
                                    {/*    <div className="flex-column">*/}
                                    {/*        <ListItem itemKey="Policy Type" itemValue={policyInformationData.type} />*/}
                                    {/*    </div>*/}
                                    {/*    <div className="flex-column">*/}
                                    {/*        <ListItem itemKey="Status" itemValue={policyInformationData.status} />*/}
                                    {/*    </div>*/}
                                    {/*    <div className="flex-column">*/}
                                    {/*        <ListItem itemKey="Purchase Date" itemValue={formatDate(policyInformationData.saleDate)} />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    {/*<div className="card-col__1 mt-11">*/}
                                    {/*    <ListItem itemKey="Provider" itemValue={policyInformationData.provider} />*/}
                                    {/*</div>*/}
                                    {/*<div className="card-col__1 mt-11">*/}
                                    {/*    <ListItem itemKey="Phone" itemValue={formatPhoneNumber(policyInformationData.phone)} />*/}
                                    {/*</div>*/}
                                </List>
                            </div>
                        </Card>
                    </div>
                    <div className="d-flex">
                        {getInvalidPolicyTypeMessage()}
                    </div>
                </React.Fragment>
            )
        }
    }

    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    )
};

PolicyInformation.propTypes = {
    direction: PropTypes.string,
    policyInformationData: PropTypes.object,
    policyExpired: PropTypes.bool
}

export default PolicyInformation;